<!-- eslint-disable vue/max-len -->
<template>
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.8" cx="8" cy="8" r="6" fill="white" />
    <path
      d="M6 6L10 10"
      stroke="#636B78"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
    <path
      d="M10 6L6 10"
      stroke="#636B78"
      stroke-width="1.5"
      stroke-miterlimit="10"
      stroke-linecap="square"
      stroke-linejoin="round"
    />
  </svg>
</template>
